import React, { useContext, useEffect, useState} from 'react';
 
import { AppContext } from "../../../providers/appProvider"
import cl from './dashboard.module.css'
import { useCar } from '../../../hooks/useCar';
import DailyChart from './DailyChart';
import MonthChart from './MonthChart';
import MonthYearsChart from './MonthYearsChart';
import WebsitesChart from './WebsitesChart';
import MakersChart from './MakersChart';

const DashboardStats = () => {
  const { carService } = useCar(-1);
  const {appState, app} = useContext(AppContext);
  const [dailyCars, setDailyCars] = useState([]);
  const [salerCars, setSalerCars] = useState([]);
  const [car30day, setCar30day] = useState(0)
  const [carMonth, setCarMonth] = useState(0)
  const [car30daySaler, setCar30daySaler] = useState(0)
  const [carMonthSaler, setCarMonthSaler] = useState(0)
  const [stats, setStats] = useState(null)

 

    useEffect(() => {
        async function fetchData() {
            const stat = await carService.getStat();
            setStats(stat)
            setDailyCars(stat.daily_stat) 
            setSalerCars(stat.saler_stat) 
            setCar30day(stat.car_30_days)
            setCarMonth(stat.car_month)
            setCar30daySaler(stat.car_30_days_saler)
            setCarMonthSaler(stat.car_month_saler)
         } 
        app.setupDefault() 
        fetchData();
    }, []); 
  

  return <div style={{maxWidth: '1280px', marginLeft: 'auto', marginRight: 'auto'}}> 
    { app.hasPermission("STATISTICS_SALE_BY_SALERS") &&  stats !== null &&
        <div className={ cl.chartBG + ' ' + cl.mb15 + ' ' + cl.mt15 }  >
          <MonthChart   data={stats} ></MonthChart>
        </div>
     }
 
    { app.hasPermission("STATISTICS_SALE_BY_SALERS_MONTH") &&  stats !== null &&
        <div className={ cl.chartBG + ' ' + cl.mb15 + ' ' + cl.mt15 }  >
          <MonthYearsChart  defaultData={stats} ></MonthYearsChart>
        </div>
     }
 
 
      { app.hasPermission("STATISTICS_SALE_BY_WEBSITE") &&  stats !== null &&
          <div className={ cl.chartBG + ' ' + cl.mb15 + ' ' + cl.mt15 }  >
            <WebsitesChart data={stats}></WebsitesChart>
          </div> 
        }

        { app.hasPermission("STATISTICS_SALE_BY_MAKER") &&  stats !== null &&
            <div className={ cl.chartBG + ' ' + cl.mb15 + ' ' + cl.mt15 }  >
              <MakersChart data={stats}></MakersChart>
            </div> 
        }
 

  </div>;
}

export default DashboardStats;